var map = {
	"./basketball.webp": 1614,
	"./bti-img.webp": 1615,
	"./bti-title-en.webp": 1616,
	"./cup.webp": 1617,
	"./football.webp": 1618,
	"./im-img.webp": 1619,
	"./im-title-en.webp": 1620,
	"./sb-img.webp": 1621,
	"./sb-title-cn.webp": 1622,
	"./sb-title-en.webp": 1623,
	"./sbo-img.webp": 1624,
	"./sbo-title-cn.webp": 1625,
	"./sbo-title-en.webp": 1626,
	"./sport-bg.webp": 1627,
	"./sport-ctg.webp": 1628,
	"./title-cn.webp": 1629,
	"./title-en.webp": 1630
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 822;